import { put, getAll, getByKey, clear } from './utils/transactionHelpers'

export async function saveReviewRequest(requestId) {
    try {
        await put('reviewRequests', { id: requestId })
    } catch (error) {
        console.error('Error saving review request:', error)
        throw error
    }
}

export async function getAllReviewRequests() {
    try {
        return await getAll('reviewRequests')
    } catch (error) {
        console.error('Error retrieving review requests:', error)
        return []
    }
}

export async function checkReviewRequestExists(requestId) {
    try {
        const result = await getByKey('reviewRequests', requestId)
        return Boolean(result)
    } catch (error) {
        console.error('Error checking review request:', error)
        return false
    }
}

export const deleteAllReviewRequests = async () => {
    try {
        await clear('reviewRequests')
        console.log('All review requests deleted successfully')
    } catch (error) {
        console.error('Error deleting review requests:', error)
        throw error
    }
}
